/* eslint-disable react/jsx-no-bind, react/forbid-prop-types, jsx-a11y/anchor-is-valid, react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import Loader from '../../components/loader';
import SuccessLogo from '../../components/logo';
import styles from './style.css';

@inject('settingsStore')
@inject('formStore')
@observer
export default class GateKeeperNotify extends React.Component {
  static propTypes = {
    settingsStore: PropTypes.object.isRequired,
    formStore: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { formStore } = this.props;
    const { setSent } = formStore;

    setSent();
  }

  handleDone = e => {
    e.preventDefault();
    this.props.formStore.reset();
    this.props.history.replace('/');
  };

  renderHelped = body => {
    const { locales } = this.props.settingsStore;
    return (
      <div className={styles.helpedContainer}>
        <div className={styles.helpedLogo}>
          <SuccessLogo />
        </div>

        <div className={styles.helpedText}>{body}</div>

        <div>
          <button className={styles.button} onClick={this.handleDone}>
            {locales.modules.support.create_new_ticket}
          </button>
        </div>
      </div>
    );
  };

  renderCreatedError = () => {
    const { locales } = this.props.settingsStore;
    return (
      <div className={styles.error}>
        <div>
          <p>{locales.general.error}</p>
        </div>
      </div>
    );
  };

  render() {
    const { locales, externalNavigation } = this.props.settingsStore;
    const { isSaving, saveError, articleHelped } = this.props.formStore;
    const showBack = !externalNavigation;
    const didHelp = !isSaving && !saveError && articleHelped;
    const hasError = !isSaving && saveError;
    const feedbackText = locales.modules.support.feedback_thanks;

    const notifyText = didHelp ? (
      <p>{feedbackText}</p>
    ) : (
      <React.Fragment>
        <p
          dangerouslySetInnerHTML={{
            __html: locales.modules.support.thankyou,
          }}
        />
      </React.Fragment>
    );

    return (
      <div>
        <div className={styles.header}>
          {showBack && (
            <div className={styles.navigation}>
              <button className={styles.button} onClick={this.handleDone}>
                {locales.general.back}
              </button>
            </div>
          )}
        </div>

        <div className={styles.bodyContainer}>
          {isSaving && <Loader className={styles.loader} />}
          {!isSaving && !hasError && this.renderHelped(notifyText)}
          {hasError && this.renderCreatedError()}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/gatekeeperNotify/index.js